// deno-fmt-ignore-file
import { CreateError } from './error.mjs';
export function FromNever(context, type) {
    throw new CreateError(type, 'Cannot create TNever types');
}
